import React, { Component } from "react";

import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import { withRouter } from "../withRouter";
import { withTheme } from "../withTheme";

class VoterNavBar extends Component {
  state = {
    imageLoaded: false,
    imageError: false,
  };

  handleImageLoad = () => {
    this.setState({ imageLoaded: true, imageError: false });
  };

  handleImageError = () => {
    this.setState({ imageLoaded: false, imageError: true });
  };

  render() {
    const { imageLoaded, imageError } = this.state;
    const hasValidImage = this.props.img && imageLoaded && !imageError;

    return (
      <Navbar
        style={{
          backgroundColor: this.props.backgroundColor,
          minHeight: "auto",
        }}
        className="py-2"
      >
        <Container
          className={
            this.props.text && hasValidImage
              ? "d-flex align-items-center gap-3"
              : "justify-content-center"
          }
        >
          {hasValidImage && (
            <Navbar.Brand
              className="fw-bold m-0"
              style={{ color: "var(--light)" }}
            >
              <img
                onLoad={this.handleImageLoad}
                onError={this.handleImageError}
                alt=""
                style={{
                  objectFit: "contain",
                  maxWidth: "100%",
                  display: "block",
                }}
                src={this.props.img}
                height="60"
                className="d-inline-block"
              />
            </Navbar.Brand>
          )}
          {this.props.text && (
            <Navbar.Text
              className={`fw-bold fs-3 text-center m-0 ${
                !hasValidImage ? "mx-auto" : ""
              }`}
              style={{ color: "var(--light)" }}
            >
              {this.props.text}
            </Navbar.Text>
          )}
        </Container>
      </Navbar>
    );
  }
}

export default withRouter(withTheme(VoterNavBar));
